import { styled } from 'goober';

import { IQuizItem } from '../../types/quiz';
import { OptionButtons } from '../parts/OptionButtons';
import { QuestionImage } from '../parts/QuestionImage';
import { QuestionText } from '../parts/QuestionText';

type Props = {
  item: IQuizItem;
  onSubmit: (value: string) => void;
};

export const SingleQuestion = ({ item, onSubmit }: Props) => {
  return (
    <Container>
      {item?.topTitle && (
        <TopTitle className="q-top-title">{item.topTitle}</TopTitle>
      )}
      <QuestionImage item={item} />
      <QuestionText item={item} />
      <OptionButtons item={item} onSubmit={onSubmit} />
    </Container>
  );
};

const Container = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const TopTitle = styled('span')`
  margin: 0;
  color: #3d3d3d;
  text-align: center;
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
`;
